import React from "react";
import LeagMainHead from "../../common/LeagMainHead";
import InfoPage from "../../football/league/InfoPage";
import LeagueWrapper from "../../football/league/LeagueWrapper";
import BasketballStandingTable from "../../common/table/BasketballStandingTable";

const BasketballLeagueWidgetWrap = (props) => {
    const {
        dataId,
        dataType,
        head,
        data,
        headData,
        baseUrl,
        sport,
        difference,
        loadCSS,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
        setDataType,
        setDataId,
        setHead,
    } = props;

    const renderHeadWrap = (currentTab, children) =>
        head ? (
            <LeagMainHead
                id={dataId}
                headData={headData}
                baseUrl={baseUrl}
                sport={"basketball"}
                dataClient={dataClient}
                currentTab={currentTab}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                widgetTitle={dataTitle}
            >
                {children}
            </LeagMainHead>
        ) : (
            children
        );

    switch (dataType) {
        case "basketball-league-info":
            return renderHeadWrap("info",
                <InfoPage
                    id={dataId}
                    sport={sport}
                    data={data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    setDataType={setDataType}
                    setDataId={setDataId}
                    setHead={setHead}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "basketball-league-upcoming":
            return renderHeadWrap("upcoming",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );

        case "basketball-league-results":
            return renderHeadWrap("results",
                <LeagueWrapper
                    sport={sport}
                    data={data?.data}
                    loadCSS={loadCSS}
                    baseUrl={baseUrl}
                    dataClient={dataClient}
                    websiteBaseUrl={websiteBaseUrl}
                    dataPath={dataPath}
                    difference={difference}
                />
            );
        case "basketball-league-standings":
            return renderHeadWrap("table",
                <BasketballStandingTable
                    sport={sport}
                    ServerData={data}
                    loadCSS={loadCSS}
                    dataClient={dataClient}
                />
            );

        default:
            return <h1>Basketball League Widget Not Found!</h1>;
    }
};

export default BasketballLeagueWidgetWrap;
